<template>
  <div class="ma-2">
    <v-data-table :headers="statusHeaders" dense :items="assignStatusList" class="bordered--table px-4 elevation-1" :loading="statusLoader">
        <template #top>
            <v-toolbar flat class="data-table-toolbar">
              <v-icon class="mx-2" @click="$router.push('/settings')">mdi-arrow-left</v-icon>
              <h4>{{ $t('message.tickets.autoAssignTicketStatus') }}</h4>
              <v-spacer></v-spacer>
              <div class="mr-n4">
                <v-btn  color="primary" outlined small @click="addNewAssignStatus(1)">
                  <v-icon size="21"> mdi-plus </v-icon>
                </v-btn>
              </div>
            </v-toolbar>
          </template>
          <template #[`item.statusName`]="{ item }">
            <v-chip small :color="item.statusColor" :text-color="$formatter.foreGroundColor(item.color)">{{ item.statusName }}</v-chip>
          </template>
          <template #[`item.isdomain`]="{ item }">
            <v-icon class="font--style"> {{ item.isdomain ? 'mdi-check' : 'mdi-close' }} </v-icon>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-btn icon color="primary" @click="editRecord(item , 'ticketautoassignstatussettings', 1)">
              <v-icon size="22"> mdi-pencil </v-icon>
            </v-btn>
            <v-btn icon color="error" @click="deleteRecord(item , 'ticketautoassignstatussettings', 1)">
              <v-icon size="22"> mdi-delete </v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-data-table :headers="userHeaders" dense :items="assignUserList" class="bordered--table px-4 elevation-1 mt-4" :loading="userLoader">
        <template #top>
            <v-toolbar flat class="data-table-toolbar">
              <h4>{{ $t('message.tickets.autoAssignTicketUser') }}</h4>
              <v-spacer></v-spacer>
              <div class="mr-n4">
                <v-btn  color="primary" outlined small @click="addNewAssignStatus(2)">
                  <v-icon size="21"> mdi-plus </v-icon>
                </v-btn>
              </div>
            </v-toolbar>
          </template>
          <template #[`item.assignedToName`]="{ item }">
            {{ item.assignedToName }}
          </template>
          <template #[`item.isdomain`]="{ item }">
            <v-icon class="font--style"> {{ item.isdomain ? 'mdi-check' : 'mdi-close' }} </v-icon>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-btn icon color="primary" @click="editRecord(item, 'ticketautoassignusersettings', 2)">
              <v-icon size="22"> mdi-pencil </v-icon>
            </v-btn>
            <v-btn icon color="error" @click="deleteRecord(item, 'ticketautoassignusersettings', 2)">
              <v-icon size="22"> mdi-delete </v-icon>
            </v-btn>
          </template>
        </v-data-table>
         <!-- Assign new status Dialog -->
    <v-dialog v-model="assignStatusDialog" width="700" persistent>
      <v-card>
        <v-card-title>
          <span v-if="modelFormType === 1"> {{ assignStatusModel.id ? $t('message.tickets.updateAutoassignStatus') : $t('message.tickets.addAutoassignStatus') }}</span>
          <span v-else> {{ assignStatusModel.id ? $t('message.tickets.updateAutoassignUser') : $t('message.tickets.addAutoassignUser') }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1">
          <form-template :references.sync="formReferences" :model="assignStatusModel" ref="statusFieldsReference" v-if="assignStatusDialog"></form-template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="primary" id="deleteConfirm" class="mr-3" @click="saveUpdateAssignStatusHandler()" :loading="loading">{{ assignStatusModel.id ? $t('message.common.update') : $t('message.common.save') }}</v-btn>
            <v-btn color="error" id="deleteClose" @click="closeAssignDialog()">{{ $t('message.common.close') }}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      statusDates: [],
      assignStatusList: [],
      assignUserList: [],
      assignStatusDialog: false,
      assignStatusModel: {},
      listOfStatusResult: [],
      loading: false,
      statusLoader: false,
      userLoader: false,
      modelFormType: 1,
      MODULE: 'ticketAssign'
    }
  },
  components: {
    'form-template': () => import('@/components/FormTemplate.vue')
  },
  computed: {
    ...mapGetters(['getListOfGroups', 'getUsers']),
    ...mapState(['FORM_TYPE']),
    statusHeaders () {
      return [{
        text: this.$t('message.common.emailAddress'),
        align: 'center',
        value: 'emailaddress'
      }, {
        text: this.$t('message.common.status'),
        align: 'center',
        value: 'statusName'
      }, {
        text: this.$t('message.tickets.isDomain'),
        align: 'center',
        value: 'isdomain'
      }, {
        text: this.$t('message.tickets.actions'),
        align: 'center',
        value: 'actions'
      }]
    },
    userHeaders () {
      return [{
        text: this.$t('message.common.emailAddress'),
        align: 'center',
        value: 'emailaddress'
      }, {
        text: this.$t('message.tickets.groupOrUser'),
        align: 'center',
        value: 'assignedToName'
      }, {
        text: this.$t('message.tickets.isDomain'),
        align: 'center',
        value: 'isdomain'
      }, {
        text: this.$t('message.tickets.actions'),
        align: 'center',
        value: 'actions'
      }]
    },
    formReferences () {
      return {
        hideTitle: true,
        fromsettings: true,
        properties: [{
          model: 'emailaddress',
          type: this.FORM_TYPE.TEXT,
          rules: this.assignStatusModel.isdomain ? this.$_domainAndRequiredValidation : this.$_emailAndRequiredValidation,
          label: this.$t('message.common.emailAddress'),
          class: 'xs6'
        }, {
          model: 'statusid',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.SELECT,
          class: 'xs6 pt-2',
          label: this.$t('message.common.status'),
          items: this.listOfStatusResult,
          select_value: 'id',
          is_visible: this.modelFormType === 1,
          select_text: 'name'
        }, {
          model: 'assignedto',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.getUsersAndGroups,
          rules: this.$_requiredValidation,
          select_text: 'name',
          select_value: 'alternateid',
          class: 'xs6',
          is_visible: this.modelFormType === 2,
          label: this.$t('message.tickets.assignedTo')
        }, {
          model: 'mustbefromorto',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.autoAssignAddressType,
          rules: this.$_requiredValidation,
          select_text: 'text',
          select_value: 'id',
          class: 'xs6',
          label: this.$t('message.tickets.is')
        }, {
          model: 'isdomain',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs3 pt-2',
          change: this.checkCurrentValue(),
          label: this.$t('message.tickets.isDomain')
        }]
      }
    },
    getUsersAndGroups () {
      let userList = this.$formatter.cloneVariable(this.getUsers)
      userList = userList.map(x => ({ ...x, name: x.fullname }))
      let groupList = this.$formatter.cloneVariable(this.getListOfGroups)
      return [ ...userList, ...groupList ]
    },
    autoAssignAddressType () {
      return [{
        id: 'from',
        text: this.$t('message.tickets.fromAddress')
      }, {
        id: 'to',
        text: this.$t('message.tickets.toAddress')
      }]
    }
  },
  mounted () {
    this.$store.dispatch('getGroups')
    this.$store.dispatch('getUsers')
    this.getListOfStatus(true)
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
      this.$store.commit('hideDialog')
      if (data === 'ticketautoassignstatussettings') this.getAssignStatusListHandler()
      else this.getAssignUserListHandler()
    })
  },
  methods: {
    getListOfStatus (initial) {
      const query = {
        'filter': 'isactive eq 1'
      }
      this.$_executeApi('post', 'ticketstatuslists/query', query).then(response => {
        this.listOfStatusResult = response.data
        this.getAssignStatusListHandler(initial)
      })
    },
    getAssignStatusListHandler (initial) {
      this.assignStatusList = []
      this.statusLoader = true
      this.$_executeApi('get', 'ticketautoassignstatussettings').then((result) => {
        if (result && result.data) {
          result.data.forEach(element => {
            let statusObj = this.listOfStatusResult.find(x => x.id === element.statusid)
            if (statusObj) {
              element.statusName = statusObj.name
              element.statusColor = statusObj.color
            } else element.statusName = 'Unknown'
          })
          this.assignStatusList = result.data
        }
        if (initial) this.getAssignUserListHandler()
      }).finally(() => {
        this.statusLoader = false
      })
    },
    checkCurrentValue () {
      if (this.assignStatusModel.isdomain) {
        if (!/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/.test(this.assignStatusModel.emailaddress)) this.$set(this.assignStatusModel, 'emailaddress', '')
      } else {
        if (!/^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(this.assignStatusModel.emailaddress)) this.$set(this.assignStatusModel, 'emailaddress', '')
      }
      if (this.$refs.statusFieldsReference) this.$refs.statusFieldsReference.$refs.validateForm.resetValidation()
      this.$forceUpdate()
    },
    addNewAssignStatus (type) {
      this.modelFormType = type
      this.assignStatusDialog = true
    },
    saveUpdateAssignStatusHandler () {
      if (this.$refs.statusFieldsReference.$refs.validateForm.validate()) {
        let model = this.$formatter.cloneVariable(this.assignStatusModel)
        let url = ''
        let method = model.id ? 'put' : 'post'
        if (this.modelFormType === 2) {
          url = model.id ? `ticketautoassignusersettings/${model.id}` : 'ticketautoassignusersettings'
          let assignedto = model.assignedto.split('_')
          if (assignedto[0] === 'user') {
            model.userid = assignedto[1]
            model.groupid = null
          } else {
            model.groupid = assignedto[1]
            model.userid = null
          }
        } else url = model.id ? `ticketautoassignstatussettings/${model.id}` : 'ticketautoassignstatussettings'
        this.loading = true
        this.$_executeApi(method, url, model).then(() => {
          this.closeAssignDialog()
          if (this.modelFormType === 2) this.getAssignUserListHandler()
          else this.getAssignStatusListHandler()
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.assignStatusModel.id ? 'updateSuccess' : 'saveSuccess' })
        }).finally(() => {
          this.loading = false
        })
      }
    },
    closeAssignDialog () {
      this.$refs.statusFieldsReference.$refs.validateForm.resetValidation()
      this.assignStatusModel = {}
      this.assignStatusDialog = false
    },
    editRecord (item, url, type) {
      this.$_executeApi('get', `${url}/${item.id}`).then(response => {
        if (type === 2) {
          response.data.assignedto = response.data.userid ? `user_${response.data.userid}` : `group_${response.data.groupid}`
        }
        this.assignStatusModel = response.data
        this.addNewAssignStatus(type)
      })
    },
    getAssignUserListHandler () {
      this.userLoader = true
      this.$_executeApi('get', 'ticketautoassignusersettings').then((result) => {
        if (result && result.data) {
          let list = result.data
          list.forEach(user => {
            if (user.userid) {
              let userObj = this.getUsers.find(x => x.id === user.userid)
              if (userObj) user.assignedToName = userObj.fullname
            }
            if (user.groupid) {
              let groupObj = this.getListOfGroups.find(x => x.id === user.groupid)
              if (groupObj) user.assignedToName = groupObj.name
            }
          })
          this.assignUserList = list
        }
      }).finally(() => {
        this.userLoader = false
      })
    },
    deleteRecord (item, url) {
      let payload = { ids: [item.id], url: `${url}/delete_multiple`, module: url }
      this.$store.commit('showDeleteDialog', payload)
    }
  }
}
</script>
